// @flow
import type { ThemeType, QuestionType } from 'types/Faq';

export function getThemeWithQuestion(themes: Array<ThemeType>, questions: Array<QuestionType>){
  const filteredThemes = (): any[] => themes.filter(
    theme => questions.filter(question => question.theme === theme.id).length > 0);
  return filteredThemes();
}
